import React from "react";
import { useNavigate } from "react-router-dom";
import { urls } from "./links";

/**
 * A real <a href> (percent-encoded, crawlable) that navigates inside the SPA
 * on a plain click. `to` is a decoded path from the shared URL builders.
 */
export default function PathLink({ to, state, replace, onClick, children, ...rest }) {
  const navigate = useNavigate();
  function handleClick(e) {
    if (onClick) onClick(e);
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey ||
      (rest.target && rest.target !== "_self")
    ) {
      return;
    }
    e.preventDefault();
    navigate(to, { state, replace });
  }
  return (
    <a href={urls.toHref(to)} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
